export type AdminTaskCategory = 'reviews' | 'payments' | 'refunds';
export interface AdminTask {
    item_key: string;
    kind: string;
    category: AdminTaskCategory;
    description: string;
    reason: string;
    status: string;
    recorded_at: string;
    reference: string | null;
    error_code: string | null;
    purchase_key: string | null;
    review_id: string | number | null;
    currency_code: string | null;
    fingerprint: string;
    dismissal_note?: string | null;
    dismissed_by?: string | null;
    dismissed_at?: string | null;
}
export interface AdminTaskSummary {
    counts: Record<AdminTaskCategory, number>;
    total: number;
    environment: string;
    generated_at: string;
}
export interface AdminTasksDto extends AdminTaskSummary {
    data: AdminTask[];
    pager: { total: number; page: number; page_size: number };
}

export function adminTaskLink(task: AdminTask, environment: string): string {
    if (task.category === 'reviews') return `/admin/reviews?${new URLSearchParams({ shared: '1', approved: '0', review: String(task.review_id) })}`;
    const query = new URLSearchParams({ environment, tab: 'attention' });
    if (task.currency_code) query.set('currency', task.currency_code);
    if (task.purchase_key) query.set('purchase', task.purchase_key);
    return `/admin/finance?${query}`;
}

export const ADMIN_TASKS_CHANGED = 'admin-tasks-changed';
export function refreshAdminTaskCount() { window.dispatchEvent(new Event(ADMIN_TASKS_CHANGED)); }
